import { Environment } from "@core/config/environment";

const SORTED_SUB_TYPES = {
	INSTITUTE:
		Environment.APP_VARIANT === "jaangal"
			? ["HIGH_SCHOOL", "MIDDLE_SCHOOL"]
			: [
					"UNIVERSITY",
					"HIGH_SCHOOL",
					"MIDDLE_SCHOOL",
					"PROFESSIONAL_TRAINING_CENTER",
					"CERTIFICATION_CENTER",
					"HIGHER_EDUCATION_INSTITUTE",
					"ACADEMY",
					"RESEARCH_CENTER",
					"GENERAL_EDUCATION_INSTITUTE",
					"POLYTECHNIC_INSTITUTE",
					"NATIONAL_HIGHER_SCHOOL",
				],
	COMPANY: [
		"ARTIST",
		"ASSOCIATION",
		"NON_PROFIT_ORGANIZATION",
		"CHARITABLE_ORGANIZATION",
		"COMMUNITY_ORGANIZATION",
		"INDIVIDUAL_COMPANY",
		"PUBLIC_COMPANY",
		"PRIVATE_COMPANY",
		"PUBLIC_FIGURE",
	],
} as const;

export type OrganizationType = keyof typeof SORTED_SUB_TYPES;
export type OrganizationSubType = (typeof SORTED_SUB_TYPES)[OrganizationType][number];

export const subTypesByTypes = SORTED_SUB_TYPES as { [key in OrganizationType]: readonly OrganizationSubType[] };
export const allOrganizationTypes = Object.keys(subTypesByTypes) as OrganizationType[];
export const allOrganizationSubTypes = allOrganizationTypes.flatMap((k) => subTypesByTypes[k]);
